var map = {
	"./astuda/Purchase/Purchase": [
		28940,
		8940
	],
	"./demo/Purchase/Purchase": [
		75124,
		5124
	],
	"./hjmetal/Purchase/Purchase": [
		95955,
		5955
	],
	"./jarsoncchon/Purchase/Purchase": [
		42479,
		2479
	],
	"./loveejan/Purchase/Purchase": [
		41053,
		1053
	],
	"./mingji/Purchase/Purchase": [
		16001,
		6001
	],
	"./morale/Purchase/Purchase": [
		80080,
		80
	],
	"./pinxuangarden/Purchase/Purchase": [
		26988,
		6988
	],
	"./ppbaby/Purchase/Purchase": [
		94801,
		4801
	],
	"./proluckmarket/Purchase/Purchase": [
		8240,
		8240
	],
	"./sshengrcm/Purchase/Purchase": [
		90644,
		644
	],
	"./testing/Purchase/Purchase": [
		64945,
		4945
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11822;
module.exports = webpackAsyncContext;